














import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';
import { Icon } from 'vant';
Vue.use(Icon);
const baseUrl = 'XLBT0911';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '作品展示',
      path: `/${baseUrl}/pathold/home`,
      id: 1,
    },
    {
      title: '活动介绍',
      path: `/${baseUrl}/rules`,
      id: 2,
    },
    {
      title: '活动数据',
      path: `/${baseUrl}/rank`,
      id: 3,
    },
  ];
  show: boolean = false;
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '“小萝卜头”进校园活动',
      url: location.href,
      subtitle: `“小萝卜头”进校园活动`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '“小萝卜头”进校园活动',
        subtitle: `“小萝卜头”进校园活动`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
